import { render, staticRenderFns } from "./AWS.vue?vue&type=template&id=4eb692df&"
import script from "./AWS.vue?vue&type=script&lang=js&"
export * from "./AWS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb692df')) {
      api.createRecord('4eb692df', component.options)
    } else {
      api.reload('4eb692df', component.options)
    }
    module.hot.accept("./AWS.vue?vue&type=template&id=4eb692df&", function () {
      api.rerender('4eb692df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/AWS.vue"
export default component.exports